import { useEffect, useState } from 'react';

/**
 * True once `active` has stayed true for `ms`. Drives the feedback budget
 * (DESIGN_SYSTEM §5): inline progress after 300 ms, determinate + Cancel after 2 s.
 */
export function useDelayed(active: boolean, ms: number): boolean {
  const [reached, setReached] = useState(false);
  useEffect(() => {
    if (!active) return;
    const t = setTimeout(() => setReached(true), ms);
    return () => {
      clearTimeout(t);
      setReached(false);
    };
  }, [active, ms]);
  return active && reached;
}
